/**************************************************
 * Nombre:       Locales_PorMayor
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import banner from '../../../Recursos/banner_mayor.png'
import {NEGRITA} from "../../../Constantes";
import {useNavigate} from "react-router-dom";
import {scrolearAComponente} from "../../../Utilidades/scrolearAComponente";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Locales_PorMayor = () => {
    const {sCell} = useResponsive()
    const navigate = useNavigate();

    const irMayoristas = () =>{

        navigate('/PorMayor')
        setTimeout(() =>{
            scrolearAComponente('Formulario')
        },500)
    }

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{
                            background: `linear-gradient(269deg, rgba(196, 196, 196, 0.00) 16.99%, #000 59.16%), url(${banner})`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                            border: 4,
                            borderColor: '#000',
                            borderRadius: 10,
                            color: '#fff',
                            px:  sCell ? 4 : 8,
                            py: sCell ? 4 : 10
                        }}
                    >


                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 6}}>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{fontFamily: NEGRITA, fontSize: sCell ? 24 : 40, lineHeight: sCell ? 1.3 : 1.1}}>DISFRUTA NUESTROS PRODUCTO AL POR
                                    MAYOR</Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                                <Typography sx={{fontSize: 16}}>Lleva el sabor de Quesuditas a tu negocio o
                                    evento con nuestros productos congelados al por mayor. Calidad, practicidad y precio
                                    justo en un solo lugar.</Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 3}}>
                                <Button
                                    onClick={() => irMayoristas()}
                                    color={'info'} >HAGÁMOSLO FÁCIL</Button>
                            </Grid>

                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Locales_PorMayor